import format from 'date-fns/format';
import parse from 'date-fns/parse';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { i18n } from '@/plugins/vue-i18n';

export const dateTimeInputFormat = "yyyy-MM-dd'T'HH:mm:ssxx";
export const dateInputFormat = 'yyyy-MM-dd';
export const dateUrlFormat = 'yyyy-MM-dd';
export const dateInputPeriodFormat = 'dd.MM.yyyy';
export const dateTimeTransferFormat = "yyyy-MM-dd'T'HH:mm:ss.SSSxxx";
// default output format, will be overwritten by localized getLocalizedDateTimeOutputFormat:
export const tableDateTimeOutputFormat = 'yyyy-MM-dd HH:mm:ss';
// export const dateTimeOutputFormat = "yyyy-MM-dd' 'HH:mm:ss"; // via common.json (localized)

export const getLocalizedDateTimeOutputFormat = (outputFormat, inputFormat, input, defaultResp = '') => {
  if (input === undefined || input === null || input === '') return defaultResp;
  const date = parse(input, inputFormat, new Date());
  return format(date, outputFormat);
};

export const formatDate = (value, format = 'date') => getLocalizedDateTimeOutputFormat(i18n.t(`common.${format}Format`), dateTimeInputFormat, value);

export const formatDateTime = (value, format = 'dateTime') => formatDate(value, format);

export const formatDateUrl = (value) => getLocalizedDateTimeOutputFormat(dateUrlFormat, dateTimeInputFormat, value, null);

export const formatTimeFromSeconds = (value) => {
  if (typeof value !== 'number' || value < 0) return '';
  const date = new Date(0, 0, 0, 0, 0, value);
  return value >= 3600 ? format(date, 'H:mm:ss') : format(date, 'm:ss');
};

export const isWithinTimeFrame = (date, timeFrame) => {
  const parsedDate = parse(date, dateTimeInputFormat, new Date());
  const differenceInDays = differenceInCalendarDays(parsedDate, new Date());
  return Math.abs(differenceInDays) < timeFrame;
};

export const formatValue = (value, format = 'date') => {
  if (!value) return '';
  if (value.textValue != null) return value.textValue;
  if (value.intValue != null) return value.intValue.toString();
  if (value.dateValue != null) return getLocalizedDateTimeOutputFormat(i18n.t(`common.${format}Format`), dateTimeInputFormat, value.dateValue);
  if (value.boolValue != null) return value.boolValue ? i18n.t('common.yes') : i18n.t('common.no');
  if (value.floatValue != null) return value.floatValue.toString();
};

export default {
  dateTimeInputFormat,
  dateInputFormat,
  dateUrlFormat,
  dateInputPeriodFormat,
  dateTimeTransferFormat,
  tableDateTimeOutputFormat,
  getLocalizedDateTimeOutputFormat,
  formatDate,
  formatDateTime,
  formatDateUrl,
  formatTimeFromSeconds,
  isWithinTimeFrame,
  formatValue,
};
